import accountForm from './accountForm'
import destroyAccountForm from './destroyAccountForm'
import emailForm from './emailForm'
import passwordForm from './passwordForm'

export default {
  accountForm,
  destroyAccountForm,
  emailForm,
  passwordForm
}



// WEBPACK FOOTER //
// ./src/store/modules/settings/index.js